var SYMBOLS = [{
  symbol: "@@__IMMUTABLE_INDEXED__@@",
  name: "Indexed",
  modifier: true
}, {
  symbol: "@@__IMMUTABLE_KEYED__@@",
  name: "Keyed",
  modifier: true
}, {
  symbol: "@@__IMMUTABLE_LIST__@@",
  name: "List",
  arrayish: true
}, {
  symbol: "@@__IMMUTABLE_MAP__@@",
  name: "Map"
}, {
  symbol: "@@__IMMUTABLE_ORDERED__@@",
  name: "Ordered",
  modifier: true,
  prefix: true
}, {
  symbol: "@@__IMMUTABLE_RECORD__@@",
  name: "Record"
}, {
  symbol: "@@__IMMUTABLE_SET__@@",
  name: "Set",
  arrayish: true,
  setish: true
}, {
  symbol: "@@__IMMUTABLE_STACK__@@",
  name: "Stack",
  arrayish: true
}];
export function immutableName(obj) {
  try {
    var symbols = SYMBOLS.filter(function (_ref) {
      var symbol = _ref.symbol;
      return obj[symbol] === true;
    });
    if (!symbols.length) return;
    var name = symbols.find(function (s) {
      return !s.modifier;
    });
    var prefix = name.name === "Map" && symbols.find(function (s) {
      return s.modifier && s.prefix;
    });
    var arrayish = symbols.some(function (s) {
      return s.arrayish;
    });
    var setish = symbols.some(function (s) {
      return s.setish;
    });
    return {
      name: "".concat(prefix ? prefix.name : "").concat(name.name),
      symbols: symbols,
      arrayish: arrayish && !setish,
      setish: setish
    };
  } catch (e) {
    return null;
  }
}